import { Img } from "globalStyles"
import React from "react"
import { AuthNavUser } from "utils/assets"
import MenuDas from "../Menu"
import { BigMenuDiv, SideImageDiv, UserDpName } from "./style"

const AuthSideNav = ({ isOpen, onClick, user }) => {
	return (
		<BigMenuDiv>
			<SideImageDiv>
				<Img src={user?.avatar?.url ? user?.avatar?.url : AuthNavUser} alt="byshelb user" />
			</SideImageDiv>
			<UserDpName>
				{user?.surname} {user?.first_name}
			</UserDpName>
			<MenuDas user={user} />
		</BigMenuDiv>
	)
}

export default AuthSideNav
